export const DASHBOARD_JOB_DESCRIPTIONS_REQUEST = "DASHBOARD_JOB_DESCRIPTIONS_REQUEST";
export const DASHBOARD_JOB_DESCRIPTIONS_RECIEVE = "DASHBOARD_JOB_DESCRIPTIONS_RECIEVE";
export const SET_JOB_DESCRIPTIONS_REQUEST="SET_JOB_DESCRIPTIONS_REQUEST"
export const DELETE_JOB_DESCRIPTIONS_REQUEST="DELETE_JOB_DESCRIPTIONS_REQUEST"
export const GET_DASHBOARD_JOB_DESCRIPTIONS_REQUEST = "GET_DASHBOARD_JOB_DESCRIPTIONS_REQUEST";
export const GET_DASHBOARD_JOB_DESCRIPTIONS_RECIEVE = "GET_DASHBOARD_JOB_DESCRIPTIONS_RECIEVE";
